import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { renderHTMLString } from '../../../../helpers';
import './BaseSectionText.scss';

export function BaseSectionText(props) {
  const {
    text,
    styled,
    className,
    style,
    jsx,
    pageConfig: { location } = {},
  } = props;

  const componentClassNames = classNames('c-base-section-text', {
    'c-base-section-text--styled': styled,
    [className]: className,
  });

  return !text ? null : (
    <div className={componentClassNames} style={style}>
      {jsx ? text : renderHTMLString(text, location)}
    </div>
  );
}

BaseSectionText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  jsx: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(BaseSectionText);
